<template>
    <div>
        <h2 is="sui-header">{{ $t('gateway.globalConfig.title') }}</h2>

        <input type="hidden" v-model="activeGateway.configuration.fetchMethod">

        <sui-form-fields :fields="'four'">
            <sui-form-field>
                <label>{{ $t('common.name') }}</label>
                <input
                    type="text"
                    placeholder="AC3, Orpi Connect, ..."
                    v-model="activeGateway.name"
                    required
                />
            </sui-form-field>

            <sui-form-field>
                <label>{{ $t('gateway.globalConfig.fileEncoding') }}</label>
                <sui-dropdown
                    :placeholder="$t('gateway.globalConfig.fileEncodingPlaceholder')"
                    selection
                    :options="setEncodingOptions"
                    v-model="activeGateway.configuration.globalConfiguration.encodingId"
                    required
                >
                </sui-dropdown>
            </sui-form-field>

            <sui-form-field>
                <label>{{ $t('gateway.globalConfig.maxDownload') }}</label>
                <input
                    type="number"
                    min="0"
                    v-model="maxMediaDownloadCount"
                    required
                />
            </sui-form-field>

            <sui-form-field>
                <label>{{ $t('gateway.config.downloadBatchLength') }}</label>
                <input type="number" step="1" min="0" max="100" v-model="downloadBatchLength">
            </sui-form-field>
        </sui-form-fields>

        <sui-form-field>
            <label>{{ $t('gateway.globalConfig.comment') }}</label>
            <textarea rows="2" v-model="activeGateway.comment"></textarea>
        </sui-form-field>

        <sui-divider section />
    </div>
</template>

<script>
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'GlobalConfig',
        props: {
            fetchMethod: String,
        },
        created() {
            this.activeGateway.configuration.fetchMethod = this.fetchMethod;
        },
        computed: {
            ...mapGetters(['activeGateway']),
            maxMediaDownloadCount: {
                get() {
                    return parseInt(this.activeGateway.configuration.globalConfiguration.maxMediaDownloadCount);
                },
                set(value) {
                    this.activeGateway.configuration.globalConfiguration.maxMediaDownloadCount = parseInt(value);
                }
            },
            downloadBatchLength: {
                get() {
                    return parseInt(this.activeGateway.configuration.globalConfiguration.downloadBatchLength);
                },
                set(value) {
                    this.activeGateway.configuration.globalConfiguration.downloadBatchLength = parseInt(value);
                }
            },
            state: {
                get() { return store.state }
            },
            setEncodingOptions() {
                return store.state.encodings.map(encoding => ({
                    text: encoding.name,
                    value: encoding.id,
                }))
            }
        },
    }
</script>
